module.exports = __webpack_public_path__ + "img/face-hand-yawn.19a9c481.svg";